module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "floorStyle"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("设置")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题："
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dataForm.title),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "title", $$v)
      },
      expression: "dataForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "左侧导航背景:"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.dataForm.LeftBackgroundColor),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "LeftBackgroundColor", $$v)
      },
      expression: "dataForm.LeftBackgroundColor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "左侧字体背景:"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.dataForm.LeftFontColor),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "LeftFontColor", $$v)
      },
      expression: "dataForm.LeftFontColor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "左侧图片挂件： 图片大小 250*440"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.dataForm.leftImg.url) ? _c('div', [_c('img', {
    staticClass: "img-pendant__uploader",
    attrs: {
      "src": _vm.dataForm.leftImg.url
    },
    on: {
      "click": function($event) {
        return _vm.handleImgChange(0)
      }
    }
  })]) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleImgChange(0)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n            ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.setTypeNavLink(-1, 0)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v("\n            " + _vm._s(_vm.dataForm.leftImg.children ? _vm.dataForm.leftImg.children.data.title : "设置路径") + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "右侧图片挂件1： 图片大小 155*280"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.dataForm.rightImg1.url) ? _c('div', [_c('img', {
    staticClass: "img-pendant__uploader",
    attrs: {
      "src": _vm.dataForm.rightImg1.url
    },
    on: {
      "click": function($event) {
        return _vm.handleImgChange(1)
      }
    }
  })]) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleImgChange(1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n            ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.setTypeNavLink(-1, 1)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v("\n            " + _vm._s(_vm.dataForm.rightImg1.children ? _vm.dataForm.rightImg1.children.data.title : "设置路径") + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "右侧图片挂件2： 图片大小 155*280"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.dataForm.rightImg2.url) ? _c('div', [_c('img', {
    staticClass: "img-pendant__uploader",
    attrs: {
      "src": _vm.dataForm.rightImg2.url
    },
    on: {
      "click": function($event) {
        return _vm.handleImgChange(2)
      }
    }
  })]) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleImgChange(2)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n            ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.setTypeNavLink(-1, 2)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v("\n            " + _vm._s(_vm.dataForm.rightImg2.children ? _vm.dataForm.rightImg2.children.data.title : "设置路径") + "\n          ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型导航项："
    }
  }, [_vm._l((_vm.dataForm.leftNavList), function(item, index) {
    return [_c('el-col', {
      key: item.uuid,
      attrs: {
        "span": 18
      }
    }, [_c('el-input', {
      model: {
        value: (item.titleName),
        callback: function($$v) {
          _vm.$set(item, "titleName", $$v)
        },
        expression: "item.titleName"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "btn-width__100",
      attrs: {
        "size": "mini"
      },
      on: {
        "click": function($event) {
          return _vm.setTypeNavLink(index)
        }
      }
    }, [_vm._v(_vm._s(item.id ? item.title : "设置路径"))])], 1), _vm._v(" "), _c('el-col', {
      key: item.uuid2,
      attrs: {
        "span": 6
      }
    }, [_c('div', {
      staticClass: "del-or-add-nav"
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.delTypeNav(index)
        }
      }
    })])])]
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.dataForm.leftNavList.length >= 9,
      "size": "mini"
    },
    on: {
      "click": _vm.addTypeNav
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v("\n            设置项目\n          ")])], 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tab类型切换："
    }
  }, [_vm._l((_vm.dataForm.tabList), function(item, index) {
    return [_c('el-col', {
      key: item.uuid,
      attrs: {
        "span": 18
      }
    }, [_c('el-input', {
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      key: item.uuid2,
      attrs: {
        "span": 6
      }
    }, [_c('div', [_c('i', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.delTabList(index)
        }
      }
    })])])]
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.dataForm.leftNavList.length >= 9,
      "size": "mini"
    },
    on: {
      "click": _vm.addTabList
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v("\n            设置Tap\n          ")])], 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择商品："
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.dataForm.activeName),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "activeName", $$v)
      },
      expression: "dataForm.activeName"
    }
  }, _vm._l((_vm.dataForm.tabList), function(items, index) {
    return _c('el-tab-pane', {
      key: items.uuid,
      attrs: {
        "label": items.title,
        "name": index + ''
      }
    }, [_vm._l((items.children), function(item, i) {
      return _c('el-col', {
        key: item.id,
        attrs: {
          "span": 24
        }
      }, [_c('el-col', {
        attrs: {
          "span": 4
        }
      }, [_c('el-image', {
        staticStyle: {
          "width": "60px",
          "height": "60px"
        },
        attrs: {
          "src": item.pics[0],
          "fit": "cover"
        }
      })], 1), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 14
        }
      }, [_c('p', {
        staticClass: "goods-name"
      }, [_vm._v(_vm._s(item.item_name))])]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 6
        }
      }, [_c('div', {
        staticClass: "del-or-add-nav"
      }, [_c('i', {
        staticClass: "iconfont el-icon-edit",
        on: {
          "click": function($event) {
            return _vm.editGoods(i)
          }
        }
      }), _vm._v("\n                    \n                  "), _c('i', {
        staticClass: "iconfont icon-trash-alt",
        on: {
          "click": function($event) {
            return _vm.delGoods(i)
          }
        }
      })])])], 1)
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-button', {
      attrs: {
        "size": "mini"
      },
      on: {
        "click": _vm.addGoods
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-plus"
    }), _vm._v("\n                设置商品\n              ")])], 1)], 2)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": function($event) {
        _vm.imgsVisible = false
      }
    }
  }), _vm._v(" "), _c('linkSetter', {
    attrs: {
      "visible": _vm.linksVisible
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": function($event) {
        _vm.linksVisible = false
      }
    }
  }), _vm._v(" "), _c('goodsPicker', {
    attrs: {
      "usage": "pc",
      "visible": _vm.goodsVisible
    },
    on: {
      "pickGoods": _vm.pickGoods,
      "closeDialog": function($event) {
        _vm.goodsVisible = false
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9bcec604", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bcec604"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/floor/style.vue
// module id = 2888
// module chunks = 0